<template>
  <f7-page login-screen id="password-forgot-screen">
    <f7-navbar back-link="Terug"></f7-navbar>
    <f7-login-screen-title>
      <img src="/static/images/logos/private-gym/logo-cropped.svg" style="width: 80%; max-width:250px; opacity: 1;" class="m-3 w-80">
    </f7-login-screen-title>
    <f7-list form class="list-strong list-outline list-dividers">
      <f7-list-input
          type="text"
          name="email"
          placeholder="Jouw email adres"
          :value="email"
          @input="email = $event.target.value"
      ></f7-list-input>
    </f7-list>
    <f7-list class="list-strong list-outline list-dividers">
      <f7-list-button @click="forgotPassword">Verstuur reset email</f7-list-button>
      <f7-block-footer>
        Je ontvangt een link om je wachtwoord te resetten. Ontvang je deze email niet? Mail dan even naar support@privategym.nl
        <br/>
        <f7-link href="/auth/reset-password">Klik hier om de wachtwoord reset code in te voeren</f7-link>
      </f7-block-footer>
    </f7-list>
  </f7-page>
</template>

<script>

import { f7, f7ready } from 'framework7-vue';

export default {
  components: {},

  props: {
    f7router: Object,
    f7route: Object,
  },

  mixins: [],

  data: function () {
    return {
      email: '',
    };
  },

  computed: {
    current_user_has_token() {
      return this.$store.getters['current_user/token'].length > 0;
    },
  },

  created() {
    //
  },

  mounted() {
    console.log('f7route forgot-password', this.f7route)
  },

  methods: {
    forgotPassword() {
      this.$store.dispatch('current_user/forgot_password', {
        email: this.email,
      }).then(response => {
        this.f7router.navigate('/auth/reset-password')
      });
    }
  },

  watch: {
    //
  }
};
</script>
